import { ImageData } from "../imageCollections";

interface TitleProps {
  painting: ImageData;
}

export default function Title({ painting }: TitleProps) {
  return (
    <div>
      {painting.title}<br />
      {painting.sold && (
        <span style={{ fontSize: "0.7em", marginLeft: 4 }}>(SOLD)</span>
      )}
    </div>
  );
}
